import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GlobalMessageService, GlobalMessageType, I18nModule } from '@spartacus/core';
import { Observable, Subscription, take } from 'rxjs';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

export interface IframeModalModel {
  modalType: string;
  src: Observable<string> | string;
}

@Component({
  selector: 'app-iframe-container-modal',
  standalone: true,
  imports: [CommonModule, I18nModule, MatProgressSpinnerModule],
  templateUrl: './iframe-container-modal.component.html',
  styleUrl: './iframe-container-modal.component.scss',
})
export class IframeContainerModalComponent implements OnInit, OnDestroy {
  @ViewChild('iframeContainer') iframeContainer: ElementRef;
  src: Observable<string> | string;
  modalType: string;
  isLoading: boolean = true;
  frameBorder = '0';

  // Subscriptions
  srcSubscription$: Subscription;

  constructor(
    private renderer: Renderer2,
    private modalService: StandardModalService,
    private messageService: GlobalMessageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res: IframeModalModel) => {
        this.modalType = res.modalType;
        this.src = res.src;
      });
  }

  ngOnInit(): void {
    if (this.src instanceof Observable) {
      this.srcSubscription$ = this.src.subscribe({
        next: (src: string) => {
          this.src = src;
          this.generateIframe();
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ key: 'error.iframe.genericError' }, GlobalMessageType.MSG_TYPE_ERROR);
        },
      });
    } else {
      this.generateIframe();
    }
  }

  generateIframe(): void {
    const iframe = this.renderer.createElement('iframe');
    iframe.src = this.src;
    iframe.frameBorder = this.frameBorder;
    setTimeout(() => {
      this.renderer.appendChild(this.iframeContainer.nativeElement, iframe);
    });
    iframe.onload = () => {
      this.isLoading = false;
    };
  }

  closeModal(reason: any): void {
    this.modalService.closeDialog(reason);
  }

  ngOnDestroy(): void {
    this.srcSubscription$?.unsubscribe();
  }
}
